<template>

    <main class="articles">

        <section class="articles__hero">

            <div class="container">

                <span class="articles__eyebrow uppercase">
                    {{ 'articles_eyebrow' | staticTitle }}
                </span>

                <h1>
                    {{ 'articles_header' | staticTitle }}
                </h1>

                <p>
                    {{ 'articles_header' | staticContent }}
                </p>

            </div>

        </section>

        <section class="articles__list">

            <div class="container">

                <div
                    v-if="articles.length"
                    class="articles__grid"
                >

                    <article
                        v-for="article in articles"
                        :key="article.id"
                        class="article-card"
                    >

                        <img
                            v-if="article.imagenes_id"
                            :src="article.imagenes_id | imageIdToURL"
                            :alt="article.title"
                        >

                        <div class="article-card__content">

                            <h2>
                                {{ article.title }}
                            </h2>

                            <div class="article-card__summary">

                                <vue-marked>
                                    {{ article.content_alt }}
                                </vue-marked>

                            </div>

                            <router-link
                                :to="{
                                    name: 'ArticleDetail',
                                    params: {
                                        id: article.id,
                                        title: article.title
                                    }
                                }"
                            >
                                {{ 'articles_read_more' | staticTitle }}

                                <span>
                                    →
                                </span>

                            </router-link>

                        </div>

                    </article>

                </div>

                <div
                    v-else
                    class="articles__empty"
                >

                    <p>
                        No articles available.
                    </p>

                </div>

            </div>

        </section>

    </main>

</template>

<script>
export default {
    name: 'Articles',

    computed: {
        articles() {
            const items =
                this.$options.filters.portfolioFetchBy(
                    'blog'
                );

            return Array.isArray(items)
                ? items
                : [];
        }
    }
};
</script>

<style lang="scss" scoped>
.articles {
    background:
        var(--gray-100);

    &__hero {
        padding:
            120px 20px
            70px;

        text-align:
            center;

        background:
            var(--dark);

        h1 {
            max-width:
                800px;

            margin:
                0 auto
                20px;

            color:
                var(--white);

            font-size:
                clamp(
                    40px,
                    7vw,
                    70px
                );

            line-height:
                1.05;
        }

        p {
            max-width:
                700px;

            margin:
                0 auto;

            color:
                var(--text-muted);

            font-size:
                17px;

            line-height:
                1.8;
        }
    }

    &__eyebrow {
        display:
            inline-block;

        margin-bottom:
            16px;

        color:
            var(--primary);

        font-size:
            12px;

        font-weight:
            700;

        letter-spacing:
            3px;
    }

    &__list {
        padding:
            70px 20px;
    }

    &__grid {
        display:
            grid;

        grid-template-columns:
            1fr;

        gap:
            24px;
    }

    &__empty {
        padding:
            70px 20px;

        text-align:
            center;

        color:
            var(--gray-600);
    }
}

.article-card {
    display:
        flex;

    flex-direction:
        column;

    overflow:
        hidden;

    background:
        var(--white);

    border:
        1px solid
        var(--gray-200);

    border-radius:
        18px;

    transition:
        var(--transition);

    img {
        display:
            block;

        width:
            100%;

        aspect-ratio:
            16 / 10;

        object-fit:
            cover;
    }

    &__content {
        display:
            flex;

        flex-direction:
            column;

        flex:
            1;

        padding:
            24px;
    }

    h2 {
        margin:
            0 0
            14px;

        color:
            var(--dark);

        font-size:
            24px;

        line-height:
            1.2;
    }

    &__summary {
        flex:
            1;

        ::v-deep p {
            margin:
                0 0
                20px;

            color:
                var(--gray-600);

            line-height:
                1.7;
        }

        ::v-deep p:last-child {
            margin-bottom:
                0;
        }
    }

    a {
        display:
            inline-flex;

        align-items:
            center;

        gap:
            8px;

        margin-top:
            22px;

        color:
            var(--primary);

        font-weight:
            600;

        text-decoration:
            none;

        transition:
            var(--transition);

        span {
            transition:
                transform .3s ease;
        }

        &:hover {
            color:
                var(--primary-hover);

            span {
                transform:
                    translateX(4px);
            }
        }
    }

    &:hover {
        transform:
            translateY(-5px);

        box-shadow:
            0 18px 40px
            rgba(0, 0, 0, .08);
    }
}

@media (min-width: 768px) {
    .articles {

        &__list {
            padding:
                90px 20px;
        }

        &__grid {
            grid-template-columns:
                repeat(2, 1fr);
        }
    }
}

@media (min-width: 1024px) {
    .articles {

        &__grid {
            grid-template-columns:
                repeat(3, 1fr);
        }
    }
}
</style>